import {
  legacyTimeRangeToTimeRangeInputValue,
  TimeRangeValue,
  timeRangeInputValueToLegacyTimeRange,
} from '@chronosphereio/core';
import { useCallback, useMemo } from 'react';
import { useTimeRange } from './TimeRangeProviderV2';

export interface LegacyTimeRange {
  timeRange: TimeRangeValue;
  setTimeRange: (next: TimeRangeValue) => void;
}

/**
 * Returns an API for working with the legacy time range format.
 */
export function useLegacyTimeRange(): LegacyTimeRange {
  const { timeRange: timeRangeV2, setTimeRange: setTimeRangeV2 } = useTimeRange();
  const timeRange = useMemo(() => timeRangeInputValueToLegacyTimeRange(timeRangeV2), [timeRangeV2]);
  const setTimeRange = useCallback(
    (next: TimeRangeValue) => {
      const v2Value = legacyTimeRangeToTimeRangeInputValue(next);
      setTimeRangeV2(v2Value);
    },
    [setTimeRangeV2]
  );
  return { timeRange, setTimeRange };
}
